import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=4b6c87c4&scoped=true"
import script from "./insights.vue?vue&type=script&lang=js"
export * from "./insights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c87c4",
  null
  
)

export default component.exports